const JOUR_LABELS = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

const JOUR_NAME_TO_NUM = {
  DIMANCHE: 0,
  LUNDI: 1,
  MARDI: 2,
  MERCREDI: 3,
  JEUDI: 4,
  VENDREDI: 5,
  SAMEDI: 6,
};

function normalizeJour(jour) {
  if (typeof jour === 'number' && !Number.isNaN(jour)) return jour;
  if (typeof jour === 'string') {
    const upper = jour.trim().toUpperCase();
    if (upper in JOUR_NAME_TO_NUM) return JOUR_NAME_TO_NUM[upper];
    const parsed = parseInt(jour, 10);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
}

function flattenHoraires(horaires = []) {
  const flat = [];
  (horaires || []).forEach((entry) => {
    if (Array.isArray(entry?.creneaux)) {
      const jour = normalizeJour(entry.jour);
      entry.creneaux.forEach((creneau, index) => {
        flat.push({
          jour,
          heureDebut: creneau.heureDebut,
          heureFin: creneau.heureFin,
          actif: creneau.actif,
          ordre: creneau.ordre ?? index,
        });
      });
      return;
    }
    flat.push({
      jour: normalizeJour(entry.jour),
      heureDebut: entry.heureDebut,
      heureFin: entry.heureFin,
      actif: entry.actif,
      ordre: entry.ordre ?? 0,
    });
  });
  return flat;
}

function isActiveHoraire(h) {
  return h?.actif !== false && h?.heureDebut && h?.heureFin && h.jour != null;
}

/** Analyse les horaires (format admin UI ou API plate) pour la carte table. */
export function analyzeTableReservationHoraires(horaires = []) {
  const active = flattenHoraires(horaires).filter(isActiveHoraire);
  const byDay = new Map();

  active.forEach((h) => {
    if (!byDay.has(h.jour)) byDay.set(h.jour, []);
    byDay.get(h.jour).push({ debut: h.heureDebut, fin: h.heureFin });
  });

  const daysWithSlots = byDay.size;
  const multiShiftDays = [...byDay.entries()].filter(([, slots]) => slots.length >= 2);
  const hasMultiShift = multiShiftDays.length > 0;
  const singleShiftOnly = daysWithSlots > 0 && !hasMultiShift;

  const summaryLines = [...byDay.entries()]
    .sort(([a], [b]) => a - b)
    .slice(0, 4)
    .map(([jour, slots]) => {
      const plages = slots.map((s) => `${s.debut}–${s.fin}`).join(', ');
      return `${JOUR_LABELS[jour] || jour} : ${plages}`;
    });

  return {
    hasAny: active.length > 0,
    daysWithSlots,
    hasMultiShift,
    singleShiftOnly,
    multiShiftDayCount: multiShiftDays.length,
    summaryLines,
  };
}
